import MovieCard from "./MovieCard";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
const MovieList = ({ movieList, title, sliderId }) => {
  const slideLeft = () => {
    const slider = document.getElementById(sliderId);
    slider.scrollLeft = slider.scrollLeft - 700;
  };

  const slideRight = () => {
    const slider = document.getElementById(sliderId);
    slider.scrollLeft = slider.scrollLeft + 700;
  };

  if (!movieList) return null;

  //Filter if object is of Person may come when GPT search or normal search is used

  const filterPerson = movieList.filter(
    (movie) => movie.media_type !== "person"
  );

  //Filter movies which dont have bacakdrop
  const filterBackdropNull = filterPerson.filter(
    (movie) => movie.backdrop_path !== null
  );

  //Sorting list using vote_count for relevant results to be first
  let sortedByVoteCount = [...filterBackdropNull];
  // console.log(backDropList)

  sortedByVoteCount.sort((a, b) => b.vote_count - a.vote_count);

  return (
    <div className="pt-1 md:pt-6 md:pb-4 px-4">
      {sortedByVoteCount.length > 0 && (
        <div>
          <h1 className="text-lg md:text-2xl pb-2 pl-10 text-white opacity-50">
            {title}
          </h1>

          <div className="flex relative items-center ">
            {sortedByVoteCount.length > 5 && (
              <MdChevronLeft
                size={40}
                onClick={slideLeft}
                className="hidden md:inline-block cursor-pointer text-white opacity-20 hover:opacity-100"
              />
            )}
            <div
              id={sliderId}
              className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide
              
              "
            >
              {sortedByVoteCount?.map((movie) => (
                <MovieCard movie={movie} key={movie.id} />
              ))}
            </div>
            {sortedByVoteCount.length > 5 && (
              <MdChevronRight
                size={40}
                onClick={slideRight}
                className="hidden md:inline-block cursor-pointer  text-white opacity-20 hover:opacity-100"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MovieList;
